import "../styles/Footer.css"
export const Footer = () => {
    return(
        <footer class="row row-cols-1 row-cols-sm-2 row-cols-md-5 py-5 my-5 border-top">
    <div class="col mb-3">
      <a href="/" class="d-flex align-items-center mb-3 link-dark text-decoration-none">
       <img src="images/heraSystemLogo.png" id="footer-logo"/>
       <p className="display-6">HeraSystem</p>
      </a>
      <p class="text-muted">© 2022</p>
    </div>

    <div class="col mb-3">

    </div>

    <div class="col mb-3">
      <h5>Platformlar</h5>
      <ul class="nav flex-column">
        <li class="nav-item mb-2"><a target="_blank" href="https://www.instagram.com/necatiefehancer/" class="nav-link p-0 text-muted">İnstagram</a></li>
        <li class="nav-item mb-2"><a target="_blank" href="https://www.linkedin.com/in/efehancer58/" class="nav-link p-0 text-muted">Linkedin</a></li>
        <li class="nav-item mb-2"><a target="_blank" href="https://github.com/necatiefehancer" class="nav-link p-0 text-muted">Github</a></li>
        <li class="nav-item mb-2"><a target="_blank" href="https://www.facebook.com/hancer5816?locale=tr_TR" class="nav-link p-0 text-muted">FaceBook</a></li>
        <li class="nav-item mb-2"><a target="_blank" href="tel:+905536854409" class="nav-link p-0 text-muted">+90 553 685 4409</a></li>
      </ul>
    </div>

    {/* <div class="col mb-3">
      <h5>Section</h5>
      <ul class="nav flex-column">
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Home</a></li>
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Features</a></li>
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Pricing</a></li>
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">FAQs</a></li>
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">About</a></li>
      </ul>
    </div>

    <div class="col mb-3">
      <h5>Section</h5>
      <ul class="nav flex-column">
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Home</a></li>
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Features</a></li>
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Pricing</a></li>
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">FAQs</a></li>
        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">About</a></li>
      </ul>
    </div> */}
  </footer>
    )
}